import { PanelTitle, PageDescription } from '@reflex/ui/components/layout/Typography';
import { Spinner } from '@reflex/ui/components/shared/Spinner';
import { BLUEPRINT_STATUS_CONFIG } from '@/lib/status-colors';
import { cn } from '@reflex/ui/lib/utils';
import type { BlueprintStatus } from '@/lib/types';

interface BlueprintBuildingNoticeProps {
  status: BlueprintStatus;
  className?: string;
}

/**
 * Friendly inline notice rendered in the agent launch surface while
 * the first/base blueprint is still being built. Driven by
 * `useBaseBlueprintBuilding` — the launch button stays disabled while
 * this is shown.
 */
export function BlueprintBuildingNotice({ status, className }: BlueprintBuildingNoticeProps) {
  const config = BLUEPRINT_STATUS_CONFIG[status];
  return (
    <div
      data-testid="blueprint-building-notice"
      data-status={status}
      className={cn(
        'flex flex-col items-center gap-3 rounded-md border border-border bg-muted/30 p-6 text-center',
        className,
      )}
    >
      <Spinner size="md" className="text-status-info" />
      <div className="space-y-1">
        <PanelTitle as="h2">Setting up your base Blueprint</PanelTitle>
        <PageDescription className="max-w-sm">
          This is a one-time setup. We&apos;re building the default devbox image for new agents.
          You&apos;ll be able to launch as soon as it&apos;s ready.
        </PageDescription>
      </div>
      <p className={cn('text-2xs font-medium', config.sidebar.className)}>{config.sidebar.text}</p>
    </div>
  );
}
